/**
 * Seletor de rotas por produto.
 * Lê REACT_APP_PRODUTO via getProduto() uma única vez no carregamento do módulo
 * e delega para a tabela de rotas correspondente.
 */
import { MsalProvider } from "@azure/msal-react";
import { getProduto, Produto } from "config/produto";
import { RotasElbb } from "./elbb";
import { RotasPremioBb } from "./premio-bb";

const ROTAS_POR_PRODUTO: Record<Produto, React.ComponentType<any>> = {
  PREMIO_BB: RotasPremioBb,
  PREMIO_ELBB: RotasElbb,
};

export const RouteList = ({ msalInstance }: any) => {
  const Rotas = ROTAS_POR_PRODUTO[getProduto()];
  return (
    <MsalProvider instance={msalInstance}>
      <Rotas msalInstance={msalInstance} />
    </MsalProvider>
  );
};
